import React from 'react';
import { Card, Container } from 'react-bootstrap';

const hideSwaggerElements = () => {
    const iframe = document.getElementById('swagger-iframe') as HTMLIFrameElement | null;
    if (iframe && iframe.contentWindow) {
        try {
            const doc = iframe.contentDocument || iframe.contentWindow.document;
            if (doc) {
                // Hide Swagger header
                const header = doc.querySelector('.swagger-ui .topbar');
                if (header) header.setAttribute('style', 'display:none!important');
                // Hide Schemas section
                const schemas = doc.querySelector('.swagger-ui .models');
                if (schemas) schemas.setAttribute('style', 'display:none!important');
            }
        } catch (e) { /* ignore cross-origin errors */ }
    }
};

const Apis = () => {
    return (
        <Container fluid className="py-4" style={{ maxWidth: 1200 }}>
            <Card className="shadow-sm border-0">
                <Card.Header style={{ background: '#f8f9fa' }}>
                    <h5 className="mb-0" style={{ fontWeight: 600, color: '#495057' }}>API Documentation</h5>
                </Card.Header>
                <Card.Body style={{ padding: 0, minHeight: '80vh', background: '#fff' }}>
                    <iframe
                        id="swagger-iframe"
                        src="http://localhost:3000/api/docs#/"
                        title="Swagger UI"
                        style={{ width: '100%', height: '80vh', border: 'none', borderRadius: 8 }}
                        allowFullScreen
                        onLoad={hideSwaggerElements}
                    />
                </Card.Body>
            </Card>
        </Container>
    );
};

export default Apis;
